import * as React from 'react';
import { EServiceId } from '../../../../../../../types/reducers/publishTerms';
import { PremiumService, StandardService, TopService } from './ServiceCards';
import { IService } from './types';

export const serviceTypeToComponent: { [key in EServiceId]: React.FC<IService> } = {
  [EServiceId.top]: TopService,
  [EServiceId.premium]: PremiumService,
  [EServiceId.paid]: StandardService,
  [EServiceId.free]: StandardService,
};
